module.exports = __webpack_public_path__ + "static/media/zenith-bank-logo.d19d3a09.svg";